import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.palette.primary.dark};
  min-height: 49px;
  top: 48px;
`;

export const HeaderTitleWrapper = styled.div`
  align-items: right;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding-right: 80px;
  width: 80%;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.15px;
  margin: 0;
  margin-top: 2px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BreadcrumbLink = styled.a`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  letter-spacing: 0.4px;
  text-decoration: none;
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

export const ItemLabel = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 12px;
  letter-spacing: 0.4px;
  margin: 0;
`;

export const BreadcrumbText = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  letter-spacing: 0.4px;
  margin: 0;
`;
